import React from 'react';
import {FieldRenderProps} from 'react-final-form';
import VerificationInput from 'react-verification-input';
import {Form} from 'semantic-ui-react';
import styled from 'styled-components';

const FormFiledSc = styled(Form.Field)`
  .ui.placeholder.segment .column &.field {
    min-width: 25rem;
  }

  .characters {
    height: 2.8rem;
  }

  .character {
    line-height: 2.5rem;
    font-size: 1.6rem;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(34, 36, 38, .15);
    border-radius: 7px;
    color: black;
    margin-left: 8px;

    &:nth-child(4) {
      margin-left: 24px;
    }
  }

  .character--inactive {
    background-color: rgba(0, 0, 0, 0.075);
    box-shadow: none;
  }

  .character--selected {
    color: black;
    border-color: #85b7d9;
    background-color: white;
  }
`;

interface ExtendedFieldRenderProps extends FieldRenderProps<string, HTMLInputElement> {
  autoFocus?: boolean
}

const FinalFormVerificationInput = (props: ExtendedFieldRenderProps) => {

  const {
    input
  } = props;

  return (
      <FormFiledSc>
        <div>
          <VerificationInput
              removeDefaultStyles
              autoFocus
              container={{
                className: "container"
              }}
              characters={{
                className: "characters"
              }}
              character={{
                className: "character",
                classNameInactive: "character--inactive",
                classNameSelected: "character--selected"
              }}
              input={input}
          />
        </div>
      </FormFiledSc>
  );
};

export default FinalFormVerificationInput;
